<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="服务记录" name="0"></el-tab-pane>
            <el-tab-pane label="操作记录" name="1"></el-tab-pane>
        </el-tabs>
        <swb-shop-device-servc-rec-list-dlg v-if="activeName == '0'" :deviceSubNoId="deviceSubNoId" :toServcWork="toServcWork"></swb-shop-device-servc-rec-list-dlg>
        <swb-shop-device-act-rec-list :showComFlag="false" :deviceXId="deviceSubNoId" :durable="durable" ref="swb_shop_device_act_rec_list" v-else></swb-shop-device-act-rec-list>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    import SwbShopDeviceServcRecListDlg from './ShopDeviceServcRecListDlg'
    Vue.regist(SwbShopDeviceServcRecListDlg);

    import SwbShopDeviceRecList from './ShopDeviceRecList'
    Vue.regist(SwbShopDeviceRecList);

    export default {
        name: 'swb-asset-case-record-dlg',
        desc: '资产档案记录',
        props: {
            deviceSubNoId: {
                type: Number,
                default: null
            },
            durable: {
                type: Boolean,
                default: false
            },
            toServcWork: {
                type: Function,
                default: null
            }
        },
        data: function () {
            return {
                theTableHeight: 408,
                //
                activeName: '0'
            }
        },
        created: function () {
            //
        },
        mounted() {
        },
        methods: {
            handleClick(){
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetCaseRecord.vue